const config = {
    loadBetsCount: 13,
    statusFilterKeys: ["All", "Open", "Settled", "Won", "Lost"],
    maxBetsSizeReconnect: 100,
};
export const getConfig = (dictionary) => {
    // Fallback to statusFilterKeys if dictionary is not properly structured
    const myBetsDict = dictionary === null || dictionary === void 0 ? void 0 : dictionary.myBetsDictionary;
    return Object.assign(Object.assign({}, config), { statusFilterLabels: myBetsDict ? [
            myBetsDict.All,
            myBetsDict.OpenStatus,
            myBetsDict.Settled,
            myBetsDict.WonStatus,
            myBetsDict.LostStatus
        ] : config.statusFilterKeys, defaultStatusFilter: "All" });
};
//# sourceMappingURL=config.js.map